module.exports = __webpack_public_path__ + "static/media/28.352e043f.mp3";